import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { EventInterface } from '../../../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../../../reduxToolkit/typedRedux';
import { getBestPresentations } from '../../../../../../../../services/services';

interface Stats {
  avgChatmessagesPerPresentation?: number;
  bestPresentations?: {
    value?: Presentation[];
  };
  meetingJoinsPerQuarter?: any[];
  numberOfDatashare?: {
    detail: string;
    value: number;
  };
  presentationsVsMeetings?: {
    detail?: string;
    value?: {
      comment: string;
      meetingAvg: number;
      presenationAvg: number;
    };
  };
  totalAttendees?: {
    value: number;
    detail: string;
  };
  totalParticipants?: {
    value: number;
    detail: string;
  };
}

interface Presentation {
  presentationTopic: string;
  users: number;
  _id: string;
}

const getMedal = (p: number) => ['🥇', '🥈', '🥉'][p] || '🏅';

export const BoothBestPresentations = () => {
  const [stats, setStats] = useState<Stats>({
    bestPresentations: { value: [] },
  });
  const event: EventInterface | null = useSelector((state) => state.common.event);
  const { t } = useTranslation('stats');
  useEffect(() => {
    fetchData();
  }, [event]);

  async function fetchData() {
    try {
      if (event) {
        const bestPresentations = await getBestPresentations(event._id);
        setStats({ bestPresentations: bestPresentations });
      }
    } catch (err) {
      console.error(err);
    }
  }
  return (
    <>
      {stats?.bestPresentations?.value?.length !== 0 && (
        <div className="mt-8 mb-2">
          <Paper elevation={3} className="p-4">
            <div className="m-2">
              <Typography className="font-size: 1rem;line-height: 1.5rem; capitalize" color="textSecondary" gutterBottom>
                {t('best-presentations')}
              </Typography>
            </div>
            <div className="container pb-10 @md:container m-8 h-96 flex justify-around">
              {stats?.bestPresentations?.value &&
                stats.bestPresentations.value.slice(0, 3).map((presentation, i) => (
                  <div
                    key={presentation._id}
                    className={`flex flex-col items-center order-${i} ${i === 0 ? 'self-start' : i === 1 ? 'self-center' : 'self-end'}`}>
                    <div className="flex flex-col space-y-4 rounded-full border-2 border-solid w-48 h-48 justify-center items-center ring-4 ">
                      <span className="text-5xl font-bold">{presentation.users}</span>
                      <span className="p-0.5 text-sm w-32">{presentation.presentationTopic}</span>
                    </div>
                    <h1 className="text-6xl">{getMedal(i)}</h1>
                  </div>
                ))}
            </div>
          </Paper>
        </div>
      )}
    </>
  );
};
